export const IconOct = ({ size }: { size: string }) => {
	if (!size) size = "24px";
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="#383e5c">
			<path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM7 9.5h6.5v2H7zm6.5-1l3 2-3 2zM10.5 12.5h6.5v2h-6.5zm0-1L7.5 13.5l3 2z" />
		</svg>
	);
};
